/*
 * court7-perf.js — Court 7 Performance-Patch (2026-05-05)
 * Ziel: Klaviyo-Onsite-Form-Hydration auf Idle verschieben, Lazy-Fallback fuer alte Safari.
 * Sicherheit: no-op falls APIs fehlen; beruehrt KEINE Theme-Vendor-Logik.
 * Rollback: assets/court7-perf.js loeschen + Include in court7-perf-head.liquid entfernen.
 */
(function () {
  'use strict';

  function deferKlaviyoForms() {
    try {
      if (window._klOnsite && typeof window._klOnsite.push === 'function') {
        window._klOnsite.push(['openForm', '']);
      }
    } catch (e) { /* silent */ }
  }

  function applyLazyFallback() {
    if ('loading' in HTMLImageElement.prototype) return;
    if (!('IntersectionObserver' in window)) return;
    var imgs = document.querySelectorAll('img:not([loading])');
    if (!imgs.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.lazySrc) img.src = img.dataset.lazySrc;
          io.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    Array.prototype.slice.call(imgs).forEach(function (img) { io.observe(img); });
  }

  function onIdle(cb) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(cb, { timeout: 2000 });
    } else {
      setTimeout(cb, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      onIdle(deferKlaviyoForms);
      onIdle(applyLazyFallback);
    }, { once: true });
  } else {
    onIdle(deferKlaviyoForms);
    onIdle(applyLazyFallback);
  }
})();
